export default {
  // modelName: 'other_data/key',
  modelName: 'app_version_management',
  label: 'APP版本管理',
};
